import axios from '@axios'

export default {
  loadTable(queryFilter) {
    let queryUrl = ''
    queryUrl = `?page=${queryFilter.page}&size=${queryFilter.size}&sort=${queryFilter.sort},${queryFilter.order}`
    if (queryFilter.filter) {
      queryUrl = `/pesquisa?${queryFilter.filter}`
    }
    return axios.get(`/financeiro/bancos${queryUrl}`)
  },
  insertNewBank(data) {
    return axios.post('/financeiro/bancos', data)
  },
  editBank(data) {
    return axios.put(`/financeiro/bancos/${data.id}`, data)
  },
  deleteBank(id) {
    return axios.delete(`/financeiro/bancos/${id}`)
  },
}
